import { useQuery } from '@tanstack/react-query';
import { IPropertyType } from '../../Interfaces/IPropertyType';
import { customFetcher } from '../useFetch';

//////////////////// PropertyTypes
export const useGePropertyTypes = () => {
  const { data: propertyTypes, isLoading: isLoadingPropertyTypes } = useQuery<
    IPropertyType[]
  >({
    refetchOnWindowFocus: false,
    queryKey: ['propertytype'],
    queryFn: () =>
      customFetcher({
        endpoint: '/propertytype',
      }),
  });

  return { propertyTypes, isLoadingPropertyTypes };
};
